import React from 'react';

import { CallCentreRegisterThankyouView } from './CallCentreRegisterThankyouView';
import { navigation } from '@origin-digital/reporting-client';

interface CallCentreRegisterThankyouPageProps {
  nextAction: () => void;
}

const CallCentreRegisterThankyouPage: React.FC<CallCentreRegisterThankyouPageProps> = ({
  nextAction,
}) => {
  React.useEffect(
    () =>
      navigation('screen', {
        currentUri: '',
        friendlyUri: 'originenergy:my-account:auth:manual-reg-create-password-success',
      }),
    [],
  );
  return <CallCentreRegisterThankyouView nextAction={nextAction} />;
};

export { CallCentreRegisterThankyouPage };
